/**
 * IntegratedQuestionnaireFlow - 新旧UIを統合した質問回答フロー
 * Requirements: 8.1, 8.2, 8.3, 10.3, 10.4, 10.5, 10.6
 * 
 * デザインバージョン:
 * - 'design': assets/design/question/ のHTMLデザインに完全準拠（デフォルト）
 * - 'legacy': 既存のQuestionnaireContainerを使用
 */
import React from 'react';
import { QuestionSet, UserAnswer, SubmitAnswerResponse } from '../types';
import { DesignQuestionnaireFlow } from './DesignQuestionnaireFlow';

interface IntegratedQuestionnaireFlowProps {
  questionSet: QuestionSet;
  onSubmit: (answers: UserAnswer[]) => Promise<SubmitAnswerResponse>;
  onNavigateToService: () => void;
  onNavigateToMyPage: () => void;
  isLoading?: boolean;
  error?: string | null;
  designVersion?: 'legacy' | 'redesign' | 'design';
  
  // レスポンシブ設定（design版では内部で処理）
  enableResponsiveLayout?: boolean;
  enableOrientationGuide?: boolean;
  preferredOrientation?: 'landscape' | 'portrait';
  forceHorizontalOnMobile?: boolean;
}

export const IntegratedQuestionnaireFlow: React.FC<IntegratedQuestionnaireFlowProps> = ({
  questionSet,
  onSubmit,
  onNavigateToService,
  onNavigateToMyPage,
  isLoading = false,
  error = null,
  designVersion = 'design', // デフォルトでデザイン準拠版を使用
}) => {
  // レガシーモードの場合は既存のQuestionnaireContainerを使用
  if (designVersion === 'legacy') {
    return (
      <div>
        <p>レガシーモードは既存のQuestionnaireContainerを使用します</p>
      </div>
    );
  }

  // デザイン準拠版（assets/design/question/ のHTMLに完全準拠）
  return (
    <DesignQuestionnaireFlow
      questionSet={questionSet}
      onSubmit={onSubmit}
      onNavigateToService={onNavigateToService}
      onNavigateToMyPage={onNavigateToMyPage}
      isLoading={isLoading}
      error={error}
    />
  );
};

export default IntegratedQuestionnaireFlow;
